/**
 * @generated SignedSource<<1bcd76705602980cb513cd59e1822b1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountBaseFragment$data = {
  readonly id: string;
  readonly externalRef: string;
  readonly name: string;
  readonly platformAccess: any | null;
  readonly createdAt: any | null;
  readonly " $fragmentType": "accountBaseFragment";
};
export type accountBaseFragment$key = {
  readonly " $data"?: accountBaseFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountBaseFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountBaseFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platformAccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "6d608a153d470c0b586634387e83a7f6";

export default node;
